import { getMaterialsAnalytics } from '../../api/analytics';
import { deletePrq, getExelExport, getPRQ, getPRQTotal } from '../../api/prq';
import { downloadFile } from '../../utils';
import { handleActionAbortController } from '../../utils/handleActionAbortController';

export const CHANGE_PRQ_VALUE = 'CHANGE_PRQ_VALUE';
export const CHANGE_PRQ_SEVERAL_VALUES = 'CHANGE_PRQ_SEVERAL_VALUES';
export const RESET_PRQ_STORE = 'RESET_PRQ_STORE';

export const GET_PRQ = 'GET_PRQ';
export const GET_PRQ_SUCCESS = 'GET_PRQ_SUCCESS';
export const GET_PRQ_ERROR = 'GET_PRQ_ERROR';

export const DELETE_PRQ = 'DELETE_PRQ';
export const DELETE_PRQ_SUCCESS = 'DELETE_PRQ_SUCCESS';
export const DELETE_PRQ_ERROR = 'DELETE_PRQ_ERROR';

export const LOAD_PRQ_FILE = 'LOAD_PRQ_FILE';
export const LOAD_PRQ_FILE_SUCCESS = 'LOAD_PRQ_FILE_SUCCESS';
export const LOAD_PRQ_FILE_ERROR = 'LOAD_PRQ_FILE_ERROR';

export const GET_PRQ_ANALYTIC = 'GET_PRQ_ANALYTIC';
export const GET_PRQ_ANALYTIC_SUCCESS = 'GET_PRQ_ANALYTIC_SUCCESS';
export const GET_PRQ_ANALYTIC_ERROR = 'GET_PRQ_ANALYTIC_ERROR';

export const downloadPRQFile = (params, actions) => {
  return async (dispatch) => {
    dispatch({ type: LOAD_PRQ_FILE });
    try {
      const response = await getExelExport(params);
      const { success, results } = response;
      if (success) {
        response.code !== 202 && downloadFile(results, 'application/zip');
        dispatch({ type: LOAD_PRQ_FILE_SUCCESS });
        if (actions.onSuccess) {
          actions.onSuccess(response);
        }
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: LOAD_PRQ_FILE_ERROR });
      if (actions.onError) {
        actions.onError(error.message);
      }
    }
  };
};

export const getPRQAnalyticAction = (function () {
  let prevController;

  return (params) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_PRQ_ANALYTIC, payload: params.cursorDirection === 'FIRST' });
      try {
        const [response, totalResponse] = await Promise.all([
          getMaterialsAnalytics(params, abortController.signal),
          getPRQTotal(
            {
              startTime: params.startEventTime,
              endTime: params.endEventTime,
              restaurantUuid: params.restaurantsUuid,
              materials: params.materials,
            },
            abortController.signal
          ),
        ]);

        const { success, results } = response;
        const { success: totalSuccess, results: total } = totalResponse;

        if (success && totalSuccess && !abortController.signal.aborted) {
          dispatch({ type: GET_PRQ_ANALYTIC_SUCCESS, payload: { results, total }, params });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error);
          dispatch({ type: GET_PRQ_ANALYTIC_ERROR });
        }
      }
    };
  };
})();

export const getPRQAction = (function () {
  let prevController;

  return (params, actions = null) => {
    return async (dispatch) => {
      const abortController = handleActionAbortController(prevController);
      prevController = abortController;
      dispatch({ type: GET_PRQ, payload: params.cursorDirection === 'FIRST' });
      try {
        const response = await getPRQ(params, abortController.signal);
        const { success, results } = response;
        if (success && !abortController.signal.aborted) {
          dispatch({ type: GET_PRQ_SUCCESS, payload: results, params });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.log(error);
          actions?.onError(error.message);
          dispatch({ type: GET_PRQ_ERROR, params });
        }
      }
    };
  };
})();

export const deletePrqAction = (uuid, actions = null) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_PRQ });
    try {
      const response = await deletePrq(uuid);
      const { success } = response;
      if (success) {
        actions?.onSuccess();
        dispatch({ type: DELETE_PRQ_SUCCESS });
      }
    } catch (error) {
      console.log(error);
      actions?.onError(error.message);
      dispatch({ type: DELETE_PRQ_ERROR });
    }
  };
};

export const changeValue = (key, value) => ({
  type: CHANGE_PRQ_VALUE,
  payload: {
    key,
    value,
  },
});

export const changeSeveralValues = (value) => ({
  type: CHANGE_PRQ_SEVERAL_VALUES,
  payload: value,
});

export const resetStore = () => ({
  type: RESET_PRQ_STORE,
});
